import { render, staticRenderFns } from "./TheComments.vue?vue&type=template&id=3ba5ff44&"
import script from "./TheComments.vue?vue&type=script&lang=js&"
export * from "./TheComments.vue?vue&type=script&lang=js&"
import style0 from "./TheComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports